import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ breakpoints, palette, spacing }) => ({
  root: {
    position: 'fixed',
    zIndex: 3,
    backgroundColor: palette.common.white,
    boxShadow:
      '0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2)',
    top: 64,
    left: 0,
    right: '100vw',
    paddingLeft: spacing(3),
    paddingRight: spacing(3),
    height: 55
  },
  title: {
    flex: '1 1 0',
    overflow: 'hidden'
  }
}))
